import { useDialog, useGrid, UseGridReturnType } from "common";
import { createContext } from "react";
import {
  getIntegrationService,
  IntegrationFormItem,
  IntegrationListItem,
} from "./integrationApi";

export type UseIntegrationListReturnType = {
  connectItem?: IntegrationListItem;
  setConnectItem: Function; //(item?: IntegrationListItem)=>void;
  connectItemDialog: any;
  editItem?: IntegrationListItem;
  setEditItem: Function; //(item?: IntegrationListItem)=>void;
  editItemDialog: any;
} & UseGridReturnType;

export const IntegrationListContext =
  createContext<UseIntegrationListReturnType>(
    {} as UseIntegrationListReturnType
  );

export default function useIntegrationList(): UseIntegrationListReturnType {
  const service = getIntegrationService();
  const list = useGrid<IntegrationFormItem, IntegrationListItem>({
    comaSeparatedSortPrarms: true,
    storageType: "urlParams",
    id: "Integrations",
    loadColumns: true,
    translationCategory: "Integration",
    confirmAttribute: "name",
    exportFilter: filter => ({
      ClientSearch: filter,
    }),
    ...service,
    loadOptions: undefined,
  });

  const [connectItem, setConnectItem, connectItemDialog] = useDialog();
  const [editItem, setEditItem, editItemDialog] = useDialog();

  return {
    ...list,
    connectItem,
    setConnectItem,
    connectItemDialog,
    editItem,
    setEditItem,
    editItemDialog,
  };
}
